var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.processing}},[_c('b-card',[_c('bar-graph',{attrs:{"v-if":_vm.graphData.series.data && _vm.graphData.series.data.length,"categories":_vm.graphData.categories,"series":_vm.graphData.series}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }